<template>
  <div :class="$style.container">
    <CircledCharacter>
      {{ stepNumber }}
    </CircledCharacter>
    <div :class="$style.content">
      <HeadingSmall>Payment Method</HeadingSmall>
      <PaymentMethodForm
        v-if="!isMinimized"
        :displayErrorsInline="true"
        :isEditMode="isEditMode"
      />
      <div
        v-if="isEditMode"
        :class="$style.buttonBar"
      >
        <Button
          v-if="hasReachedSection"
          :data-test-id="$testId('cancel')"
          hasNoBackground
          text="Cancel"
          type="primary"
          @click="handleCancel"
        />
        <Button
          :data-test-id="$testId('continue')"
          hasOutline
          :isDisabled="!areRequiredPaymentMethodFieldsSet"
          :isLoading="isPrimaryButtonLoading"
          :text="hasReachedSection ? 'Continue' : 'Review'"
          type="secondary"
          @click="handleContinue"
        />
      </div>
    </div>
    <div v-if="!isEditMode && hasReachedSection">
      <IconButton
        :data-test-id="$testId('edit')"
        hasNoBackground
        hasOutline
        icon="edit"
        text="edit"
        type="informational"
        @click="handleEdit"
      />
    </div>
  </div>
</template>
<script>
import { Button, HeadingSmall, IconButton } from '@jumpcloud/ui-components';
import {
  PaymentMethodForm,
  PaymentSubmission,
  paymentModuleName,
} from '@jumpcloud/ui-payments';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters, mapState } from 'vuex';
import { paymentFormSections } from 'client/Payments/constants/PaymentConstants';
import CircledCharacter from 'client/Payments/newComponents/CircledCharacter.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  location,
  section,
  text: textEventProp,
} = eventProperties;
const {
  paymentMethodSection,
} = paymentFormSections;

const settingsModule = 'SettingsModule';

export default {
  name: 'PaymentMethodSection',

  PaymentSubmission,
  EventHelper,

  components: {
    Button,
    CircledCharacter,
    HeadingSmall,
    IconButton,
    PaymentMethodForm,
  },

  props: {
    hasReachedSection: Boolean,
    isEditMode: Boolean,
    isMinimized: Boolean,
    location: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isPrimaryButtonLoading: false,
    };
  },

  computed: {
    ...mapGetters(paymentModuleName, [
      'areRequiredPaymentMethodFieldsSet',
    ]),

    ...mapState(settingsModule, ['orgId']),
  },

  created() {
    this.PaymentSubmission = new this.$options.PaymentSubmission(this.$store);
    this.PaymentSubmission.initializeParameters(this.orgId, false);
    this.PaymentSubmission.initializeNmi(this.handleSuccess, this.handleError);
  },

  methods: {
    ...mapActions(paymentModuleName, [
      'resetCollectJsState',
    ]),

    handleCancel() {
      this.resetCollectJsState();
      this.$emit('cancelled');
    },

    handleContinue() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Continue clicked on Payment Method Section',
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Continue',
      });
      this.resetCollectJsState();
      this.isPrimaryButtonLoading = true;
      this.PaymentSubmission.collectJsStartPaymentRequest();
    },

    handleEdit() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Edit clicked on Payment Method Section',
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Edit',
      });
      this.$emit('clickedEdit', paymentMethodSection);
    },

    handleError() {
      this.isPrimaryButtonLoading = false;
    },

    handleSuccess() {
      this.isPrimaryButtonLoading = false;
      this.$emit('clickedContinue', paymentMethodSection);
    },
  },
};
</script>
<style module scoped>
.buttonBar {
  display: flex;
  gap: var(--jc-spacer-large);
  justify-content: flex-end;
}

.container {
  display: flex;
  gap: var(--jc-spacer);
}

.content {
  flex-grow: 1;
}
</style>
